import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=f5ec44a2&"
import script from "./offers.vue?vue&type=script&lang=js&"
export * from "./offers.vue?vue&type=script&lang=js&"
import style0 from "./offers.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5ec44a2')) {
      api.createRecord('f5ec44a2', component.options)
    } else {
      api.reload('f5ec44a2', component.options)
    }
    module.hot.accept("./offers.vue?vue&type=template&id=f5ec44a2&", function () {
      api.rerender('f5ec44a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/offers/offers.vue"
export default component.exports